import { useSiteSettings } from "@/hooks/useSiteSettings";
import { MessageCircle } from "lucide-react";

/**
 * Prominent bottom-of-Home strip inviting shoppers to start a WhatsApp
 * conversation. Hidden by admin toggle or when whatsapp_number is empty.
 */
export default function WhatsappStrip() {
  const settings = useSiteSettings();
  if (!settings) return null;
  if (settings.whatsapp_strip_enabled === false) return null;
  const num = (settings.whatsapp_number || "").replace(/[^\d]/g, "");
  if (!num) return null;
  const msg = encodeURIComponent(settings.whatsapp_message || "");
  const href = `https://wa.me/${num}${msg ? `?text=${msg}` : ""}`;
  return (
    <section
      className="relative overflow-hidden bg-[#0A0A0A] text-white border-t border-[#1a1a1a]"
      data-testid="whatsapp-strip"
    >
      {/* subtle green glow accent */}
      <div className="pointer-events-none absolute -top-32 -right-32 h-96 w-96 rounded-full bg-[#25D366]/10 blur-3xl" />
      <div className="container-ping relative py-14 md:py-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="max-w-xl">
          <div className="flex items-center gap-2 mb-3">
            <span className="block h-px w-8 bg-[#25D366]" />
            <p className="label-caps text-[#25D366]">Talk to us</p>
          </div>
          <h2 className="heading-2 leading-tight">
            {settings.whatsapp_strip_heading || "Talk to a PING specialist on WhatsApp"}
          </h2>
          {settings.whatsapp_strip_text && (
            <p className="mt-4 text-white/70 max-w-lg leading-relaxed">
              {settings.whatsapp_strip_text}
            </p>
          )}
        </div>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe57] text-white pl-6 pr-3 py-3 text-sm font-bold uppercase tracking-[0.15em] btn-transition self-start md:self-auto"
          data-testid="whatsapp-strip-cta"
        >
          <MessageCircle className="h-5 w-5" />
          Chat on WhatsApp
          <span className="inline-flex h-9 w-9 items-center justify-center bg-white/15 group-hover:bg-white/25 btn-transition">
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
            </svg>
          </span>
        </a>
      </div>
    </section>
  );
}
